// src/tiles/TotalInterviewsPill.jsx
import React from 'react';
import { Chip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

export default function TotalInterviewsPill({ count = 0 }) {
  return (
    <Chip size="small" icon={<PersonIcon />} label={`${count} interviews`} />
  );
}
